import ButtonMui from '@material-ui/core/Button';
import Popper from '@material-ui/core/Popper';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  position: relative;
  .modal {
    min-width: 401px;
    .body {
      max-width: 331px;
    }
  }
`;

/**
 * Estilização do componente ModalBody
 */
export const ModalBody = styled.div`
  min-height: 150px;
  
  .coordinatesCreated{
    padding-right: 2px;
    overflow-y: auto;  
    scroll-behavior: smooth;
    height: 300px;    
  }

  /* TODO mover para componente separado do Select */
  .MuiOutlinedInput-notchedOutline {
    border-color: rgb(0 0 0 / 58%);
  }

  .MuiButton-containedPrimary{
    background-color: #3c71dd;
  }
  .MuiButton-label{
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: #ffffff;
    text-transform: none;
  }

  .btnAddCoord{
    margin-bottom: 10px !important;
  }
  button {
    color: #3c71dd;
    background: #fff;
    border: none;

    &:hover {
      border: none;
    }

    &:disabled {
      color: #aeaeae;
    }
  }

  &#save_modal_body {
    padding-top: 22px;
    overflow: hidden;
  }

  .selects_grid {
    display: grid;
    grid-template-columns: calc(60% - 12px) calc(40% - 12px);
    grid-template-rows: 100%;
    column-gap: 20px;
    margin-bottom: 24px;
  }

  .coords_grid {
    display: grid;
    grid-template-columns: calc(50% - 12px) calc(50% - 12px);
    grid-template-rows: 100%;
    column-gap: 20px;
    margin-bottom: 10px;

    &.reverse {
      > div:last-child {
        grid-row: 1; // move o segundo elemento para a primeira linha
      }
    }

    & ~ button:first-of-type {
      margin-bottom: 24px;
      display: block;
      position: relative;
      font-size: 12px;
    }
  }

  footer {
    border-top: 1px solid #e6e6e6;
    text-align: center;
    padding-top: 14px;

    .restore-button {
      font-size: 12px;
      line-height: 16px;
    }
  }

  .pseudo_reorder_table {
    display: grid;
    height: 40px;
    padding: 10px 50px 10px 30px;
    grid-template-columns: 17% 34.3% 34.3%;
    grid-template-rows: 100%;
    background: #dbe7ff;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #5e5e5e;
  }

  .dorpable-list {
    max-height: 275px;
    overflow: scroll;
  }

  .text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.6);
  }
`;

/**
 * Estilização do componente ToolOptions
 */
export const ToolOptions = styled(Popper)`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.primaryColorDark};
  min-width: 100px;
  height: 40px;
  z-index: 400;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5) inset;
  padding: 0 10px;
  .lineSide{
    height: 22px;
    display: flex;
    border-left: 1px solid #3C71DD; 
    margin: 0 4px;
  }
  .btnActions{
    width: 31px;
    height: 40px;
  }
`;

/**
 * Estilização do componente DrawOptions
 */
export const DrawOptions = styled(Popper)`
  display: flex;
  flex-direction: column;
  z-index: 400;
  background: ${({ theme }) => theme.primaryColor};

  button {
    padding: 5px 6px;
  }
`;

/**
 * Estilização do componente StyledDraggableItem
 */
export const StyledDraggableItem = styled.div`
  position: relative;
  padding: 15px 70px 15px 30px;
  display: grid;
  grid-template-columns: 20% 40% 40%;
  grid-template-rows: 100%;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: #5e5e5e;

  .left_options {
    position: absolute;
    top: 16px;
    left: 5px;
  }

  .right_options {
    position: absolute;
    top: 16px;
    right: 5px;
    display: flex;
    button {
      border: none;
      margin: 0 4px;
      background: none;
    }
  }
`;

/**
 * Estilização do componente TabsWrapper
 */
export const TabsWrapper = styled.div`
  .MuiTabs-root {
    padding-top: 12px;
    .MuiTab-root {
      min-width: 90px;
      &:hover {
        border-bottom: none;
      }
      .MuiTab-wrapper {
        font-family: Roboto;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        text-transform: capitalize;
        color: #5e6366;
      }
    }
    .MuiTabs-indicator {
      height: 3px;
      background: #3c71dd;
    }
  }
  hr {
    margin: 0;
    position: relative;
    width: calc(100% + 70px);
    left: -35px;
    border-top: 1px solid #e6e6e6;
  }
`;

/**
 * Estilização do componente CSVImport
 */
export const CSVImport = styled.div`
  /* TODO mover para componente separado do Select */
  .MuiOutlinedInput-notchedOutline {
    border-color: rgb(0 0 0 / 58%);
  }

  .MuiFormControl-root {
    margin: 0;
  }

  .flex-row {
    display: flex;
    width: 100%;
    margin-bottom: 24px;
  }
  .text {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.6);
  }
`;

/**
 * Estilização do componente ImportButton
 */
export const ImportButton = styled(ButtonMui)`
  &.MuiButton-root {
    background: #3c71dd;
    border-radius: 3px;
    width: 185.14px;
    height: 40px;

    .MuiButton-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: #ffffff;
      text-transform: none;
    }
  }
`;

/**
 * Estilização do componente CsvFile
 */
export const CsvFile = styled.div`
  width: 100%;
  height: 113px;
  border: 2px dashed #aeaeae;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .file-info {
    margin-left: 5px;
    flex-grow: 1;
    p {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 16px;
      color: #ababab;
      margin: 0;
      overflow-wrap: anywhere;
    }
  }
  .remove-button {
    color: #7b8084;
    margin-bottom: 10px;
    &:hover {
      border: none;
    }
  }
`;
